import { render, staticRenderFns } from "./SpThreeModule2.vue?vue&type=template&id=0c3f7d8f&scoped=true"
import script from "./SpThreeModule2.vue?vue&type=script&lang=js"
export * from "./SpThreeModule2.vue?vue&type=script&lang=js"
import style0 from "./SpThreeModule2.vue?vue&type=style&index=0&id=0c3f7d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f7d8f",
  null
  
)

export default component.exports